/** 职称服务 */
import request from "@/utils/request"

/** 职称认定申请 */
export function affirmationSubmit(data) {
  return request({
    url: "/professional/affirmation/submit",
    method: "post",
    data
  })
}

/** 职称评审申请 */
export function reviewSubmit(data) {
  return request({
    url: "/professional/review/submit",
    method: "post",
    data
  })
}
/** 职称确认申请 */
export function confirmSubmit(data) {
  return request({
    url: "/professional/confirm/submit",
    method: "post",
    data
  })
}
